const htmlOptions = {
  toolbar: [
    "bold",
    "italic",
    "link",
    "header2",
    "header3",
    "header4",
    "subscript",
    "superscript",
    "bulletList",
    "orderedList",
    "clean",
  ],
};

export default htmlOptions;
